<p-dialog
  [(visible)]="visible"
  (onHide)="onHide()"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: dialogWidth }"
  styleClass="entity-channel-picker-dialog"
  [header]="dialogHeader"
  appendTo="body"
>
  <ng-container *ngIf="!showCreateForm; else createForm">
    <p class="ecp-subtitle">
      Choose an existing channel or start a new one for this {{ entityType }}.
    </p>

    <div class="ecp-list">
      <button
        type="button"
        *ngFor="let ch of channels"
        class="ecp-item"
        (click)="selectChannel(ch.id)"  
      >
        <span class="ecp-item-icon">
          <i class="pi pi-comments"></i>
        </span>
        <span class="ecp-item-body">
          <span class="ecp-item-name">{{ getChannelDisplayName(ch) }}</span>
          <span *ngIf="ch.last_message" class="ecp-item-preview">{{ ch.last_message }}</span>
        </span>
        <span *ngIf="ch.last_message_at" class="ecp-item-date">
          {{ formatLastMessageAt(ch.last_message_at) }}
        </span>
        <span *ngIf="ch.unread_count > 0" class="ecp-badge">{{ ch.unread_count }}</span>
      </button>
    </div>

    <button class="ecp-add-btn" type="button" (click)="startCreate()">
      <span class="ecp-add-icon">
        <i class="pi pi-plus"></i>
      </span>
      <span>New Channel</span>
    </button>

  </ng-container>

  <ng-template #createForm>

    <div class="ecp-form">
      <label class="ecp-label" for="newEntityChannelName">Channel name</label>
      <input
        id="newEntityChannelName"
        pInputText
        type="text"
        class="ecp-input"
        placeholder="e.g. Billing, Care team, Intake…"
        [(ngModel)]="newChannelName"
        autofocus
      />
    </div>

    <div class="ecp-form ecp-members-section">
      <label class="ecp-label" for="entityChannelMemberSearch">Add members</label>

      <div *ngIf="selectedMembers.length > 0" class="ecp-selected-members">
        <span *ngFor="let member of selectedMembers" class="ecp-member-chip">
          <span class="ecp-member-chip-name">{{ member.user_name }}</span>
          <button
            type="button"
            class="ecp-member-chip-remove"
            (click)="removeMember(member.user_id)"
            title="Remove member"
          >
            <i class="pi pi-times"></i>
          </button>
        </span>
      </div>

      <div class="ecp-member-search-wrap">
        <i class="pi pi-search ecp-member-search-icon"></i>
        <input
          id="entityChannelMemberSearch"
          pInputText
          type="text"
          class="ecp-input ecp-member-search-input"
          placeholder="Search by name or email…"
          [(ngModel)]="memberSearchQuery"
          (ngModelChange)="onMemberSearchInput()"
        />
        <i *ngIf="memberSearching" class="pi pi-spin pi-spinner ecp-member-search-spin"></i>
      </div>

      <div class="ecp-member-results" (scroll)="onMemberResultsScroll($event)">
        <button
          type="button"
          *ngFor="let user of memberSearchResults"
          class="ecp-member-result"
          (click)="addMember(user)"
        >
          <span class="ecp-member-result-avatar">
            <span class="ecp-member-result-avatar-initials" aria-hidden="true">{{ user.user_name.charAt(0).toUpperCase() }}</span>
            <img
              *ngIf="user.profile_pic_url"
              [clAvatar]="user.profile_pic_url"
              [alt]="user.user_name"
            />
          </span>
          <span class="ecp-member-result-body">
            <span class="ecp-member-result-name">{{ user.user_name }}</span>
            <span class="ecp-member-result-meta">
              <span *ngIf="user.email">{{ user.email }}</span>
              <span *ngIf="user.role_name">{{ user.role_name }}</span>
            </span>
          </span>
          <i class="pi pi-plus ecp-member-result-add"></i>
        </button>

        <div *ngIf="memberLoadingMore" class="ecp-member-loading-more">
          <i class="pi pi-spin pi-spinner"></i>
        </div>

        <div
          *ngIf="!memberSearching && memberSearchQuery.length >= 2 && memberSearchResults.length === 0"
          class="ecp-member-empty"
        >
          No users found
        </div>
        <div
          *ngIf="memberSearchQuery.length > 0 && memberSearchQuery.length < 2"
          class="ecp-member-empty"
        >
          Type at least 2 characters to search
        </div>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <ng-container *ngIf="!showCreateForm; else createFooter">
      <button
        pButton
        label="Cancel"
        class="p-button-text cancel-btn"
        (click)="onHide()"
      ></button>
    </ng-container>
    <ng-template #createFooter>
      <button
        pButton
        label="Back"
        class="p-button-text cancel-btn"
        (click)="cancelCreate()"
      ></button>
      <button
        pButton
        label="Create & open"
        class="ms-2 save-btn"
        [disabled]="creating"
        [loading]="creating"
        (click)="submitCreate()"
      ></button>
    </ng-template>
  </ng-template>
</p-dialog>
